
<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                <el-form :inline="true" ref="q" :model="q" class="demo-form-inline h-formBorder" label-width="120px">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="用户编码" prop="userCode">
                            <el-input v-model.trim="q.userCode" placeholder="" @keyup.enter.native="handleFilter"
                                      maxlength="255" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="用户名称" prop="userName">
                            <el-input v-model.trim="q.userName"   @keyup.enter.native="handleFilter"
                                      maxlength="255" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="产品大类" prop="oneLId">
                            <brselectlazy category="product_level" :v="q.oneLId" v-model="q.oneLId"
                                          :clearable="true"                                          style="width:100%"/>
                        </el-form-item>
                    </div>
                    <div class="h-formBtnOut h-columnCenter">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetForm('q')">重置</el-button>
                        <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                                   @click="addEditDialog('','add')">新增
                        </el-button>
                    </div>
                </el-form>
                </div>
            </div>
            <!--    搜索结束-->
            <!--    表格开始-->
            <div class="h-table h-mrt30">
                <el-table
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    :data="tableData"                    style="width: 100%"
                    :border="true"
                    max-height="440"
                >
                    <el-table-column
                        fixed
                        type="index"
                        label="#"
                        width="40">
                    </el-table-column>
                    <el-table-column
                        prop="userCode"
                        label="用户编码"
                        min-width="150"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="userName"
                        label="用户名称"
                        min-width="150"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="oneLId"
                        label="产品大类编码"
                        min-width="150"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="oneLName"
                        label="大类名称"
                        min-width="150"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="cuname"
                        label="创建人"
                        min-width="150"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>

                    <el-table-column
                        prop="cdate"
                        label="创建日期"
                        min-width="150"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="lucode"
                        label="修改人"
                        min-width="150"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="ldate"
                        label="修改日期"
                        min-width="150"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>


                    <el-table-column
                        label="操作"
                        width="120"
                        fixed="right"
                    >
                        <template slot-scope="scope">
                            <div style="white-space: nowrap;">
                                <el-button type="text" size="small" class="h-tableLink h-btn"
                                           @click="addEditDialog(scope.row,'edit')">编辑
                                </el-button>
                                <el-button type="text" size="small" class="h-tableLink h-btn"
                                           @click="delPlan(scope.$index,scope.row)">删除
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportExcel">批量导出
                        </el-button>
                    </div>

                    <div class="h-pagination2">
                        <pagination :page="q" @query="query" />
                    </div>
                </div>
            </div>

        <!--    表格结束-->
        <!--    新增和编辑弹窗开始-->
            <div>
                <el-dialog :close-on-click-modal="false" class="h-dialog2" :visible.sync="dialogFormVisible">
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>{{ this.title }}</h1>
                            </div>
                        </div>
                    </div>
                    <div class="h-formLine">
                        <el-form :model="addEditFrom" ref="addEditFrom" :rules="rules" :inline="true"   class="demo-ruleForm h-formbLine h-dialogForm">

                            <el-form-item  label="用户编码" prop='userCode' class="h-elformWrap-2"  >
                                <el-input v-model.trim="addEditFrom.userCode" placeholder="请输入工号" @change="getUser"></el-input>
                            </el-form-item>
                            <el-form-item label="用户名称" prop="userName" class="h-elformWrap-2" >
                                <el-input v-model.trim="addEditFrom.userName" placeholder="输入用户编码自动带出" maxlength="255" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="产品大类" prop="oneLId" class="h-elformWrap-2" >
                                <brselectlazy category="product_level" :v="addEditFrom.oneLId" @change="oneLChange"
                                              v-model="addEditFrom.oneLId"
                                              :clearable="true"
                                />
                            </el-form-item>
                            <el-form-item label="大类编码" class="h-elformWrap-2" >
                                <el-input v-model.trim="addEditFrom.oneLId" placeholder="选择产品大类自动带出" disabled></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="()=>dialogFormVisible=false">取 消</el-button>
                        <el-button class="h-btn h-formBtn h-bgblue2" @click="submit">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
        <!--    新增和编辑弹窗结束-->
    </div>
    </div>
</template>
<script>    import ss from '../../api/SystemService'
import updownfile from "@/utils/updownfile";

export default {
    name: "userOneL",
    data() {
        return {
            q: {  //搜索表单
                userCode: '',//用户编码
                userName: '',//用户名称
                oneLId: '',//产品大类编码
                oneLName: '',//大类名称
                pageSize: 10,
                pageNo: 1,
                total: 0,
            },
            //新增和编辑
            addEditFrom: {
                id: '',
                userCode: '',//用户编码
                userName: '',//用户名称
                oneLId: '',//产品大类编码
                oneLName: '',//大类名称
            },
            rules: {
                userCode: [
                    {required: true, message: '请输入用户编码', trigger: 'blur'},
                ],
                userName: [
                    {required: true, message: '请输入用户名称', trigger: 'blur'},
                ],
                oneLId: [
                    {required: true, message: '请选择产品大类', trigger: 'blur'},
                ],
            },
            dialogFormVisible: false,//新增和编辑弹窗开关
            title: '用户大类维护',
            tableData: [], //表格数据集合
            multipleSelection: [],
        }
    },

    //加载页面默认执行
    created() {
        this.query();
    },
    beforeRouteLeave(to, from, next) {
        from.meta.keepAlive = false;
        next();
    },
    activated() {
        this.query();
    },

    methods: {
        curChange() {//点击分页调用
            this.query();
        },
        handleSizeChange(val) {
            this.q.pageNo = 1
            this.q.pageSize = val
            this.query()
        },
        handleCurrentChange(val) {
            this.q.pageNo = val;
            this.query()
        },
        //产品大类选择回调，联动带出大类名称
        oneLChange(obj) {
            if (obj && obj.code) {
                this.$set(this.addEditFrom, 'oneLId', obj.code);//大类编码
                this.$set(this.addEditFrom, 'oneLName', obj.name);//大类名称
            } else {
                this.$set(this.addEditFrom, 'oneLId', '');//大类编码
                this.$set(this.addEditFrom, 'oneLName', '');//大类名称
            }
        },
        //提交
        submit() {
            this.$refs.addEditFrom.validate((valid) => {
                if (!valid) {
                    return false;
                }
                let obj = JSON.parse(JSON.stringify(this.addEditFrom))
                //新增
                if (this.addEditFrom.optionsType === 'add') {
                    ss.chanpin.insertUserOneL(obj).then(res => {
                        if (res.f == true) {
                            this.$message.success(res.msg);
                            this.dialogFormVisible = false;
                            this.query();
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                } else if (this.addEditFrom.optionsType === 'edit') {
                    //修改
                    ss.chanpin.updateUserOneL(obj).then(res => {
                        if (res.f == true) {
                            this.$message.success(res.msg);
                            this.dialogFormVisible = false;
                            this.query();
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }
            })
        },
        //点击新增或编辑
        addEditDialog(row, type) {
            this.dialogFormVisible = true;
            if (type == 'edit') { //编辑
                this.title = '用户大类修改';
                this.$set(this.addEditFrom, 'optionsType', 'edit');
                this.$set(this.addEditFrom, 'id', row.id);
                this.$set(this.addEditFrom, 'userCode', row.userCode);//用户编码
                this.$set(this.addEditFrom, 'userName', row.userName);//用户名称
                this.$set(this.addEditFrom, 'oneLId', row.oneLId);//产品大类编码
                this.$set(this.addEditFrom, 'oneLName', row.oneLName);//大类名称
            } else {
                this.title = '用户大类新增';
                this.$set(this.addEditFrom, 'optionsType', 'add');
                this.$set(this.addEditFrom, 'id', '');
                this.$set(this.addEditFrom, 'userCode', '');//用户编码
                this.$set(this.addEditFrom, 'userName', '');//用户名称
                this.$set(this.addEditFrom, 'oneLId', '');//产品大类编码
                this.$set(this.addEditFrom, 'oneLName', '');//大类名称
            }
            this.$nextTick(() => {
                this.$refs.addEditFrom && this.$refs.addEditFrom.clearValidate();
            });
        },
        //重置
        resetForm(formName) {
            this.q.userCode = '';
            this.q.userName = '';
            this.q.oneLId = '';
            this.q.oneLName = '';
            this.query();
        },
        //查询翻页
        query() {
            ss.chanpin.selectUserOneL(this.q).then(res => {
                this.q.total = res.total;
                this.tableData = res.records;
                console.log("this.tableData",this.tableData)
            })
        },
        handleFilter() {
            this.q.pageNo = 1;
            this.query();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //删除框
        delPlan(index, q) {
            this.$confirm('确认删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            })
                .then(_ => {
                    //如果原来有数据
                    if (q.id != null) {//把要删除的主键id存起来
                        ss.chanpin.deleteUserOneL({id: q.id}).then(res => {
                            if (res.f == true) {
                                this.$message.success(res.msg);
                                this.dialogFormVisible = false;
                                this.query();
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    }
                })
                .catch(_ => {
                });
        },
        //检查用户是否存在
        getUser(code){
            ss.UserService.selectById(code).then(rd => {
                if(rd.obj==null){
                    this.$msg.msge(code+"该用户在系统中不存在！");
                    this.addEditFrom.userCode = '';
                }else{
                    this.addEditFrom.userCode = code;
                    this.addEditFrom.userName = rd.obj.username;;

                }
            })
        },
        //明细导出
        exportExcel() {
            var idlist = [];
            this.multipleSelection.forEach(element => {
                idlist.push(element.id);
            });
            updownfile.down("/api/swyl/v1/demo/bscEanNotifyUser/downloadExcel", this.q, "get", 'data');
        },
    },

    mounted() {
    },
}
</script>

<!--弹窗样式结束-->
